<template>
  <div v-if="loaded && data && data.enabled" class="refer">
    <div class="rhead">
      <h3><i class="fa-solid fa-gift"></i> Refer a friend</h3>
      <span class="rterms" v-if="data.terms">{{ data.terms }}</span>
      <span class="rterms" v-else>Give ${{ fmt(data.friend_credit) }} off, get ${{ fmt(data.referrer_credit) }} credit.</span>
    </div>
    <p class="rlede">
      Share your code. Your friend gets <b>${{ fmt(data.friend_credit) }}</b> off their first
      order (over ${{ fmt(data.min_order) }}), and you get <b>${{ fmt(data.referrer_credit) }}</b>
      credit in your wallet once they’ve paid.
    </p>

    <div class="codebox">
      <div class="code">{{ data.code }}</div>
      <button class="rbtn" @click="copy(data.code)"><i class="fa-solid fa-copy"></i> Copy code</button>
      <button class="rbtn" @click="copy(data.share_url)"><i class="fa-solid fa-link"></i> Copy link</button>
      <button v-if="canShare" class="rbtn primary" @click="share"><i class="fa-solid fa-share"></i> Share</button>
    </div>

    <div class="rstats">
      <div class="rstat"><div class="rv">{{ data.referred_count }}</div><div class="rl">Friends referred</div></div>
      <div class="rstat"><div class="rv">${{ fmt(data.total_earned) }}</div><div class="rl">Credit earned</div></div>
      <div class="rstat"><div class="rv">${{ fmt(data.wallet_balance) }}</div><div class="rl">Wallet balance</div></div>
    </div>
    <p v-if="copied" class="rcopied">Copied to clipboard ✓</p>
  </div>
</template>

<script>
import caxios from '../../axios';

export default {
  name: 'ReferAFriend',
  data() { return { data: null, loaded: false, copied: false }; },
  async created() {
    try { this.data = (await caxios.get('/referrals/me/')).data; } catch (e) { /* hidden if unavailable */ }
    this.loaded = true;
  },
  computed: {
    canShare() { return typeof navigator !== 'undefined' && !!navigator.share; },
  },
  methods: {
    fmt(v) { return (Math.round((Number(v) || 0) * 100) / 100).toFixed(2).replace(/\.00$/, ''); },
    copy(text) {
      if (navigator.clipboard) { navigator.clipboard.writeText(text); this.copied = true; setTimeout(() => { this.copied = false; }, 2000); }
    },
    async share() {
      try {
        await navigator.share({
          title: 'CHDS — healthy meals delivered',
          text: `Use my code ${this.data.code} for a discount on your first CHDS order!`,
          url: this.data.share_url,
        });
      } catch (e) { /* user cancelled */ }
    },
  },
};
</script>

<style scoped>
.refer { background: #fff; border: 1px solid #e7e8e3; border-radius: 16px; padding: 20px 22px; margin: 16px 0; }
.rhead { display: flex; align-items: baseline; justify-content: space-between; flex-wrap: wrap; gap: 8px; }
.rhead h3 { font-size: 18px; font-weight: 700; color: #1f2421; margin: 0; }
.rhead h3 i { color: #446936; margin-right: 6px; }
.rterms { font-size: 12.5px; font-weight: 600; color: #446936; background: #eaf3de; padding: 3px 10px; border-radius: 999px; }
.rlede { font-size: 13.5px; color: #5a615b; margin: 10px 0 16px; line-height: 1.5; }
.codebox { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }
.code { font-family: monospace; font-size: 20px; font-weight: 700; letter-spacing: 1px; color: #1f2421; background: #f4f6f0; border: 1px dashed #cfd8c0; border-radius: 10px; padding: 10px 16px; }
.rbtn { display: inline-flex; align-items: center; gap: 6px; border: 1px solid #dfe1da; background: #fff; color: #3b423c; border-radius: 9px; padding: 9px 14px; font-size: 13px; cursor: pointer; }
.rbtn.primary { background: #446936; color: #fff; border-color: #446936; }
.rstats { display: flex; gap: 22px; margin-top: 18px; }
.rstat .rv { font-size: 20px; font-weight: 800; color: #1f2421; }
.rstat .rl { font-size: 11.5px; color: #8a908a; }
.rcopied { font-size: 12px; color: #446936; margin: 8px 0 0; }
@media (max-width: 560px) { .code { font-size: 17px; } .rstats { gap: 16px; } }
</style>
